import { makeAutoObservable } from 'mobx';

/**
 * 디바이스 기능 감지 스토어
 * - 클라이언트에서 한 번만 초기화하여 전역에서 재사용
 */
class DeviceStore {
    /**
     * hover 기능 지원 여부 (데스크탑 등 마우스 환경)
     */
    hasHoverCapability = false;

    /**
     * 클라이언트에서 마운트되었는지 여부
     */
    isMounted = false;

    constructor() {
        makeAutoObservable(this);
    }

    /**
     * 클라이언트 환경에서 디바이스 기능 초기화
     * - 앱 시작 시 한 번만 호출
     */
    init() {
        if (typeof window === 'undefined') {
            return;
        }

        // hover 기능과 정밀한 포인터(마우스)가 있는지 확인
        this.hasHoverCapability = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        this.isMounted = true;
    }
}

const deviceStore = new DeviceStore();

export default deviceStore;
